/**
 * V2 Sticky CTA — show when the hero ATC is fully out of the viewport; hide when any
 * pixel of it returns. Figma: section-sticky cta (563:4374).
 */
(function () {
  const BAR_SELECTOR = '[data-v2-sticky-cta]';
  const ATC_SELECTOR = '[data-v2-product-hero-atc]';

  function closestSectionRoot(bar) {
    return bar.closest('[id^="shopify-section-"]') || document;
  }

  function setVisible(bar, visible) {
    bar.classList.toggle('is-visible', visible);
    bar.toggleAttribute('inert', !visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    const button = bar.querySelector('.v2-sticky-cta__button');
    if (button) {
      if (visible) button.removeAttribute('tabindex');
      else button.setAttribute('tabindex', '-1');
    }
  }

  function initStickyCta(bar) {
    if (!bar || bar.dataset.v2StickyCtaReady === 'true') return;

    const root = closestSectionRoot(bar);
    const atc = root.querySelector(ATC_SELECTOR);
    if (!atc) return;

    bar.dataset.v2StickyCtaReady = 'true';

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Show whenever the hero ATC is fully outside the viewport, including
          // when it starts below the fold. Hide as soon as any pixel is visible.
          setVisible(bar, !entry.isIntersecting);
        });
      },
      { threshold: 0, root: null, rootMargin: '0px' }
    );

    observer.observe(atc);
    bar._v2StickyCtaObserver = observer;
  }

  function initAll() {
    document.querySelectorAll(BAR_SELECTOR).forEach(initStickyCta);
  }

  function destroy(bar) {
    if (bar._v2StickyCtaObserver) {
      bar._v2StickyCtaObserver.disconnect();
      bar._v2StickyCtaObserver = null;
    }
    delete bar.dataset.v2StickyCtaReady;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    const target = event.target;
    if (!target || !target.querySelector) return;
    const bar = target.matches && target.matches(BAR_SELECTOR) ? target : target.querySelector(BAR_SELECTOR);
    if (bar) {
      destroy(bar);
      initStickyCta(bar);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const target = event.target;
    if (!target || !target.querySelector) return;
    const bar = target.matches && target.matches(BAR_SELECTOR) ? target : target.querySelector(BAR_SELECTOR);
    if (bar) destroy(bar);
  });
})();
